import { Icon, Loader } from '@cinch/ui';
import React, { useState, useContext, useEffect, useRef } from 'react';
import { getter, getCustomerFieldValue } from './utils';
import { PhoneText } from 'shared/phone-text.component';
import { formatEntityDataField, getCaseInsensitiveValue } from 'shared/utils';
import { Scoped } from 'kremling';
import moment from 'moment-timezone';
import { getSegments, createCustomerSegment, deleteCustomerSegment, retireCustomerRefsVehicle, restoreCustomerRefsVehicle, splitCustomerRefs } from '../../../shared/common.api';
import { getAircallAccounts } from '../../../pages/integrations/integrations.resource';
import { DynamicTypeAhead } from 'components/dynamic-type-ahead/dynamic-type-ahead.component';
import { toasterService } from 'components/toaster/toaster-service';
import { UserStateContext } from 'context/user-state-context';
import { CallModal } from '../../../pages/cinch-phones/call-modal.component';
import { DrawerCreateTaskButton } from './create-task-button.component';
import utils from '../../../shared/utils';
import { Box, Paper, Typography, Stack, Tooltip, IconButton, Table, TableHead, TableRow, TableCell, TableBody, Button, Popper, ClickAwayListener, DialogContentText, useMediaQuery } from '@mui/material';
import { AddCircleFilledIcon, CallFilledIcon, CancelIcon, CarrotDownIcon, CarrotUpIcon, CustomerInfoFilledIcon, CustomerInfoIcon, DoubleCarrotDownIcon, DoubleCarrotUpIcon, JoinInnerIcon, JoinLeftIcon, LocationOnFilledIcon, MailEnvelopeFilledIcon, MoreHorizontalIcon, NotesFilledIcon, NotesIcon, OpenInNewWindowIcon, SegmentIcon, StatusDotIcon, SubscriptionsFilledIcon, SubscriptionsIcon, VehicleFilledIcon, VehicleIcon, DeleteIcon, EjectIcon, UndoIcon } from 'components/mui';
import { CinchActionButton, CinchDialog } from 'components';
import { useCinchNotes } from 'components/library/notes/use-cinch-notes';
import CinchNotesList from 'components/library/notes/cinch-notes-list.component';
import { getDrawerSummaryFields } from 'shared/drawer-summary-fields';
import { isChipDisplay } from 'shared/field-display';
import { FieldValue } from 'components/field-value/field-value.component';
export function DetailsComponent(props) {
  const isMobile = useMediaQuery('(max-width:900px)');
  // These props are a lazy way to pass data around.  (Mostly the unsubscribe/resubscribe stuff).  We need to optimize this later.
  const {
    customer,
    availableModels,
    availableModelsFields,
    customerDetails,
    unsubscribeCustomer,
    unsubscribeCustomerSMS,
    resetCustomerSMS,
    isLoading,
    loadCustomerDetails,
    goToVehicle
  } = props;
  const {
    asCompany,
    hasPermission,
    hasIntegration,
    flags
  } = useContext(UserStateContext);
  // CIN-7090. The LaunchDarkly key has a hyphen, so it can't be read with dot access.
  const showNotes = !!flags?.['customerdrawer-Notes'] && hasPermission('notes.view_note');
  // Hooks can't be conditional: with no objectId the hook skips its fetch entirely.
  const customerNotes = useCinchNotes({
    objectId: showNotes ? customer?.id : undefined,
    type: 'customer'
  });
  const aircallWorkspaceRef = useRef(null);
  const [showMoreCustomerFields, setShowMoreCustomerFields] = useState(false);
  const [showMoreSegments, setShowMoreSegments] = useState(false);
  const [showMoreCustomerRefs, setShowMoreCustomerRefs] = useState(false);
  const [showMoreVehicles, setShowMoreVehicles] = useState(false);
  const [showMoreAnimals, setShowMoreAnimals] = useState(false);
  const [showMoreSubscriptions, setShowMoreSubscriptions] = useState(false);
  const [showOptOutSMS, setShowOptOutSMS] = useState(false);
  const [cantOptInSMS, setCantOptInSMS] = useState(false);
  const [customerInfoExpanded, setCustomerInfoExpanded] = useState(true);
  const [optStatusMenuAnchorEl, setOptStatusMenuAnchorEl] = React.useState(null);
  const [optStatusMenu, setOptStatusMenu] = React.useState(null);
  const [customerMatchingExpanded, setCustomerMatchingExpanded] = useState(false);
  const [onHover, setOnHover] = useState(null);
  const [staticSegmentExpanded, setStaticSegmentExpanded] = useState(false);
  const [vehiclesExpanded, setVehiclesExpanded] = useState(false);
  const [animalsExpanded, setAnimalsExpanded] = useState(false);
  const [subscriptionExpanded, setSubscriptionExpanded] = useState(false);
  const [expandAll, setExpandAll] = useState(false);
  const [notesExpanded, setNotesExpanded] = useState(false);
  const [noteToDelete, setNoteToDelete] = useState(null);

  // Add to segment modal
  const [showModal, setShowModal] = useState(false);
  // Click-to-dial confirmation. Local state rather than ModalContext: the customer drawer
  // is mounted outside ModalContextProvider, so that context isn't available here.
  const [callModal, setCallModal] = useState(null);
  const [selectedSegment, setSelectedSegment] = useState();
  const [removeCustomerModal, setRemoveCustomerModal] = React.useState(null);

  // Vehicle retire/restore modal
  const [vehicleActionModal, setVehicleActionModal] = useState(null);
  const [showRemovedVehicles, setShowRemovedVehicles] = useState(false);

  // Split Customer Refs modal
  const [showSplitModal, setShowSplitModal] = useState(false);
  const [splitPreviewData, setSplitPreviewData] = useState(null);
  const [selectedCustomerRefToSplit, setSelectedCustomerRefToSplit] = useState(null);
  const [isLoadingSplitPreview, setIsLoadingSplitPreview] = useState(false);
  const [hasAircallCredentials, setHasAircallCredentials] = useState(false);
  useEffect(() => {
    if (hasIntegration('aircall') && asCompany?.id) {
      getAircallAccounts({
        company: asCompany.id
      }).then(({
        results
      }) => {
        setHasAircallCredentials(results.length > 0);
      }).catch(() => {
        setHasAircallCredentials(false);
      });
    }
  }, [hasIntegration, asCompany?.id]);
  const showAircallWorkspace = () => {
    const el = document.getElementById('aircall-workspace');
    if (el) {
      el.style.left = 'auto';
      el.style.top = 'auto';
      el.style.right = '20px';
      el.style.bottom = '20px';
      el.style.zIndex = '9999';
      el.style.width = '376px';
      el.style.height = '666px';
    }
  };
  const dialWithAircall = (workspace, phoneNumber) => {
    workspace.send('dial_number', {
      phone_number: phoneNumber
    }, (success, data) => {
      console.log('Aircall dial result:', success, data);
      if (success) {
        showAircallWorkspace();
      } else {
        console.error('Aircall dial failed:', data);
      }
    });
  };
  const handleCinchPhonesDial = () => {
    setCallModal({
      phone: customer.phone,
      name: [customer.first_name, customer.last_name].filter(Boolean).join(' ')
    });
  };
  const handleAircallDial = () => {
    if (aircallWorkspaceRef.current) {
      aircallWorkspaceRef.current.isLoggedIn(success => {
        if (success) {
          dialWithAircall(aircallWorkspaceRef.current, customer.phone);
        } else {
          showAircallWorkspace();
        }
      });
    } else {
      import('aircall-everywhere').then(({
        default: AircallWorkspace
      }) => {
        const aircallWorkspace = new AircallWorkspace({
          domToLoadWorkspace: '#aircall-workspace',
          onLogin: () => dialWithAircall(aircallWorkspace, customer.phone)
        });
        aircallWorkspaceRef.current = aircallWorkspace;
      });
    }
  };
  const addCustomerToSegment = () => {
    setShowModal(false);
    createCustomerSegment({
      customer: customer.id,
      segment: selectedSegment.id
    }).then(({
      data
    }) => {
      toasterService.success('Customer successfully added to segment.');
      customerDetails.segments.push({
        id: data.id,
        segment_id: selectedSegment.id,
        segment_name: selectedSegment.name
      });
    }).catch(err => {
      if (err.response && err.response.data.non_field_errors) {
        toasterService.error(err.response.data.non_field_errors[0]);
      } else {
        toasterService.error('Unknown error trying to add customer to segment.');
      }
    }).then(() => {
      setSelectedSegment(null);
    });
  };
  const deleteSegment = id => {
    deleteCustomerSegment(id).then(() => {
      toasterService.success('Customer successfully removed from segment.');
      customerDetails.segments = customerDetails.segments.filter(s => s.id !== id);
      // Hacky way to rerender view... TODO fix this right
      setSelectedSegment(selectedSegment === null ? false : null);
    }).catch(() => {
      toasterService.error('Unknown error trying to delete customer from segment.');
    });
  };
  const formatField = (field, value) => {
    if (value === undefined || value === null || value === '') {
      return <Typography variant="nullData" color={'#BEBEBE'}>
          <span>--</span>{' '}
        </Typography>;
    }
    if (field.type === 'datetime' || field.type === 'date') {
      const date = moment(value);
      if (!date.isValid()) {
        return <Typography variant="nullData" color={'#BEBEBE'}>
            <span>--</span>{' '}
          </Typography>;
      }
      value = field.type === 'datetime' ? date.local().format('MMM D, YYYY h:mm A') : date.format('MMM D, YYYY');
    }
    if (field.id == 'index_rank' || field.id == 'predicted_visit_next_12_months' || field.id == 'predicted_spend_next_12_months') {
      return <span>{value?.toFixed(2)}</span>;
    }
    return <span>{value}</span>;
  };
  const resubscribeSMS = () => {
    if (customerDetails.sms_optstatus === 'opt_out') {
      setCantOptInSMS(true);
    } else {
      resetCustomerSMS();
      setCantOptInSMS(false);
    }
  };
  const handleOptStatusMenuClose = () => {
    setOptStatusMenuAnchorEl(null);
    setOptStatusMenu(null);
  };
  const handleOptStatusMenuClick = (event, type) => {
    if (!!optStatusMenu) {
      handleOptStatusMenuClose();
    } else {
      setOptStatusMenu(type);
      setOptStatusMenuAnchorEl(event.currentTarget);
    }
  };
  const handleExpandAllClick = () => {
    setExpandAll(!expandAll);
    setCustomerInfoExpanded(!expandAll);
    setCustomerMatchingExpanded(!expandAll);
    setStaticSegmentExpanded(!expandAll);
    setVehiclesExpanded(!expandAll);
    setAnimalsExpanded(!expandAll);
    setSubscriptionExpanded(!expandAll);
    setNotesExpanded(!expandAll);
    setExpandAll(!expandAll);
  };
  const makeOverflowTooltip = (content, length, bold) => {
    const contentLength = content?.length || content?.props?.children?.length;
    if (content) {
      return <Tooltip title={contentLength > length ? <> {content} </> : ''}>
          <Typography variant={bold ? 'tableHeader' : ''}>
            {contentLength > length ? <>{('' + (content.props?.children || content)).slice(0, length) + '...'}</> : <>{content}</>}
          </Typography>
        </Tooltip>;
    }
    return <Typography variant="nullData" color={'#BEBEBE'}>
        <span>--</span>{' '}
      </Typography>;
  };
  const closeVehicleActionModal = () => {
    setVehicleActionModal(null);
  };
  const confirmVehicleAction = async () => {
    try {
      const {
        type,
        ref
      } = vehicleActionModal;
      const payload = ref.vehicle_id ? {
        vehicle_id: ref.vehicle_id
      } : {
        company_vehicle_id: ref.company_vehicle_id,
        customer_id: customer.id
      };
      if (type === 'remove') {
        await retireCustomerRefsVehicle(asCompany.id, payload);
      } else {
        await restoreCustomerRefsVehicle(asCompany.id, payload);
      }
      closeVehicleActionModal();
      loadCustomerDetails();
    } catch (error) {
      console.error(error);
      toasterService.error(vehicleActionModal?.type === 'remove' ? 'Unable to retire this vehicle.' : 'Unable to restore this vehicle.');
      closeVehicleActionModal();
    }
  };
  const handleSplitCustomerRef = async customerRefId => {
    if (!flags.split_customer) return;
    setSelectedCustomerRefToSplit(customerRefId);
    setIsLoadingSplitPreview(true);
    setShowSplitModal(true);
    try {
      const response = await splitCustomerRefs({
        customer_ref_ids: [customerRefId],
        dry_run: true
      });
      setSplitPreviewData(response.data);
    } catch (error) {
      console.error('Error fetching split preview:', error);
      toasterService.error('Error loading split preview');
      setShowSplitModal(false);
    } finally {
      setIsLoadingSplitPreview(false);
    }
  };
  const executeSplit = async () => {
    if (!flags.split_customer || !selectedCustomerRefToSplit) return;
    try {
      await splitCustomerRefs({
        customer_ref_ids: [selectedCustomerRefToSplit],
        dry_run: false
      });
      toasterService.success('Customer reference successfully split into new customer');
      setShowSplitModal(false);
      setSplitPreviewData(null);
      setSelectedCustomerRefToSplit(null);
      loadCustomerDetails();
    } catch (error) {
      console.error('Error executing split:', error);
      toasterService.error('Error splitting customer reference');
    }
  };
  const closeSplitModal = () => {
    setShowSplitModal(false);
    setSplitPreviewData(null);
    setSelectedCustomerRefToSplit(null);
  };
  const customerModel = availableModelsFields.find(model => model.id === 'customer');
  // Shared with the Data Fields page (CIN-6756), which marks these same fields "Shows in the customer
  // drawer", so the two always agree on which fields fill the first five rows here.
  const drawerSummary = getDrawerSummaryFields(customerModel ? customerModel.fields : []);
  return <>
      {isLoading ? <Loader sx={{
      pt: '25px'
    }} /> : <Stack sx={{
      height: '100%'
    }} className="d-flex h-100 justify-content-between">
          <Stack sx={{
        'overflowY': 'scroll',
        'scrollbarWidth': 'thin',
        '&::-webkit-scrollbar': {
          width: '0.4em'
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          marginTop: '25px',
          marginBottom: '25px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#555'
        }
      }}>
            <Box sx={{
          borderTop: '1px solid #EDEFF1',
          borderBottom: '1px solid #EDEFF1'
        }}>
              <Stack spacing={'10px'} sx={{
            'pt': '28px',
            'pb': customerInfoExpanded ? '0px' : '28px',
            'px': '24px',
            'display': 'flex',
            'alignItems': 'center',
            'alignContent': 'center',
            'cursor': 'pointer',
            'backgroundColor': customerInfoExpanded ? '#F3F6FC' : '#ffffff',
            ':hover': {
              backgroundColor: '#F3F6FC'
            }
          }} onClick={() => setCustomerInfoExpanded(!customerInfoExpanded)}>
                <Box className="d-flex w-100 justify-content-between">
                  <Box sx={{
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center'
              }}>
                    {customerInfoExpanded ? <CustomerInfoFilledIcon /> : <CustomerInfoIcon />}
                    <Typography sx={{
                  pl: '16px'
                }} fontSize={'20px'}>
                      Customer Info
                    </Typography>
                  </Box>
                  {customerInfoExpanded ? <CarrotUpIcon /> : <CarrotDownIcon />}
                </Box>

                {customerInfoExpanded && <Table sx={{
              cursor: 'default'
            }} onClick={e => e.stopPropagation()}>
                    <colgroup>
                      <col width="70%" />
                      <col width="30%" />
                    </colgroup>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <Typography variant="tableHeader">Basic Info </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="tableHeader"> Opt Status </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      alignContent: 'center'
                    }}>
                            <CallFilledIcon />
                            <Typography sx={{
                        pl: '10px'
                      }} component="div">
                              <PhoneText>{utils.formatPhoneNumber(customer.phone) || 'No Phone Number'}</PhoneText>
                            </Typography>
                            {hasIntegration('cinch_phones') && customer.phone && <Tooltip title="Call with Cinch Phones">
                                {/* Labelled rather than icon-only: the number already has a phone
                                    icon to its left, so a second bare one reads as decoration. */}
                                <Button size="small" startIcon={<CallFilledIcon fontSize="small" />} onClick={handleCinchPhonesDial} sx={{
                          'ml': '8px',
                          'textTransform': 'none',
                          // White pill, matching the opt-status button in the next
                          // cell. The explicit hover keeps it from picking up MUI's
                          // grey overlay and looking like it changed colour.
                          'backgroundColor': '#ffffff',
                          'borderRadius': '36px',
                          'height': '32px',
                          'minWidth': 0,
                          'px': '12px',
                          'boxShadow': '0px 1px 2px rgba(0, 0, 0, 0.1)',
                          '&:hover': {
                            backgroundColor: '#ffffff'
                          }
                        }}>
                                  Dial
                                </Button>
                              </Tooltip>}
                            {hasIntegration('aircall') && hasAircallCredentials && customer.phone && <Tooltip title="Dial with Aircall">
                                <IconButton size="small" sx={{
                          ml: '4px'
                        }} onClick={handleAircallDial}>
                                  <CallFilledIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>}
                            <div id="aircall-workspace" style={{
                        position: 'fixed',
                        left: '-9999px',
                        top: '-9999px'
                      }} />
                          </Box>
                        </TableCell>
                        <TableCell>
                          {customer.phone ? <Button sx={{
                      backgroundColor: '#ffffff',
                      borderRadius: '36px',
                      height: '32px'
                    }} onClick={e => {
                      e.stopPropagation();
                      handleOptStatusMenuClick(e, 'sms');
                    }}>
                              {customerDetails.sms_optstatus ? <Stack direction="row" spacing="4px" sx={{
                        px: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center'
                      }}>
                                  <StatusDotIcon fill={customerDetails.sms_optstatus == 'opt_in' ? '#66CC99' : customerDetails.sms_optstatus == 'suppressed' ? '#FAB021' : '#F30F0F'} />
                                  <Typography sx={{
                          textTransform: 'none',
                          whiteSpace: 'nowrap'
                        }}>
                                    {customerDetails.sms_optstatus == 'opt_in' ? ' Opt In' : customerDetails.sms_optstatus == 'suppressed' ? 'Suppressed' : customerDetails.sms_optstatus == 'opt_out' ? 'Opt Out' : 'Pending'}
                                  </Typography>
                                  {!!optStatusMenu && optStatusMenu == 'sms' ? <CarrotUpIcon /> : <CarrotDownIcon />}
                                </Stack> : <Stack direction="row" spacing="4px" sx={{
                        px: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center'
                      }}>
                                  <Typography sx={{
                          textTransform: 'none',
                          whiteSpace: 'nowrap'
                        }}>No Status</Typography>
                                  {!!optStatusMenu && optStatusMenu == 'sms' ? <CarrotUpIcon /> : <CarrotDownIcon />}
                                </Stack>}
                            </Button> : <Typography sx={{
                      pl: '12px'
                    }}> No Phone</Typography>}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      alignContent: 'center'
                    }}>
                            <MailEnvelopeFilledIcon size="sm" />
                            <Typography sx={{
                        pl: '10px',
                        textDecoration: customer.email ? 'underline' : 'none'
                      }}>
                              {customer.email || 'No Email'}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          {customer.email ? <Button sx={{
                      backgroundColor: '#ffffff',
                      borderRadius: '36px',
                      height: '32px'
                    }} onClick={e => {
                      e.stopPropagation();
                      handleOptStatusMenuClick(e, 'email');
                    }}>
                              {customerDetails.email_optstatus ? <Stack direction="row" spacing="4px" sx={{
                        px: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center'
                      }}>
                                  <StatusDotIcon fill={customerDetails.email_optstatus == 'subscribed' ? '#66CC99' : customerDetails.email_optstatus == 'pending' || customerDetails.email_optstatus == 'suppressed' ? '#FAB021' : '#F30F0F'} />
                                  <Typography sx={{
                          textTransform: 'none',
                          whiteSpace: 'nowrap'
                        }}>
                                    {customerDetails.email_optstatus == 'subscribed' ? 'Subscribed' : customerDetails.email_optstatus == 'blocked' ? 'Blocked' : customerDetails.email_optstatus == 'pending' ? 'Pending' : customerDetails.email_optstatus == 'suppressed' ? 'Suppressed' : 'Unsubscribed'}
                                  </Typography>
                                  {!!optStatusMenu && optStatusMenu == 'email' ? <CarrotUpIcon /> : <CarrotDownIcon />}
                                </Stack> : <Stack direction="row" spacing="4px" sx={{
                        px: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center'
                      }}>
                                  <Typography sx={{
                          textTransform: 'none',
                          whiteSpace: 'nowrap'
                        }}>No Status</Typography>
                                  {!!optStatusMenu && optStatusMenu == 'email' ? <CarrotUpIcon /> : <CarrotDownIcon />}
                                </Stack>}
                            </Button> : <Typography sx={{
                      pl: '12px'
                    }}> No Email</Typography>}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={2}>
                          <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      alignContent: 'center'
                    }}>
                            <LocationOnFilledIcon />
                            {!customer.address1 && !customer.address2 && !customer.city && !customer.state && !customer.zip_code ? <Typography sx={{
                        pl: '10px'
                      }}>No Address </Typography> : <Typography sx={{
                        pl: '10px'
                      }}>
                                {makeOverflowTooltip([[customer.address1, customer.address2].filter(Boolean).join(' '), [customer.city, customer.state].filter(Boolean).join(', '), customer.zip_code].filter(Boolean).join(' '), 75)}
                              </Typography>}
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{
                    p: 0,
                    borderBottom: 0
                  }} colSpan={2}>
                          <Table>
                            <colgroup>
                              <col width="30%" />
                              <col width="70%" />
                            </colgroup>
                            <TableBody>
                              {availableModels.indexOf('customer') > -1 && (showMoreCustomerFields ? drawerSummary.expanded : drawerSummary.collapsed).map((field, index) => {
                          const fieldValue = customer[field.id];
                          // CIN-7177: fields given chip rules on the Data Fields page, when the
                          // data-fields-redesign flag is on (index.component.js). Every other
                          // field keeps the rendering below, unchanged.
                          if (props.fieldDisplayOn && isChipDisplay(field)) {
                            return <TableRow key={index}>
                                          <TableCell>
                                            <Box sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  alignContent: 'center'
                                }}>
                                              <Typography variant="tableHeader">{field.name}</Typography>
                                            </Box>
                                          </TableCell>
                                          <TableCell>
                                            <FieldValue field={field} value={getCustomerFieldValue(customer, field)} empty={<Typography variant="nullData" color={'#BEBEBE'}>
                                                  <span>--</span>
                                                </Typography>} />
                                          </TableCell>
                                        </TableRow>;
                          }
                          return field.id.substring(0, 13) !== 'entity_data__' && field.id.substring(0, 15) !== 'appended_data__' ?
                          // This code is expecting profile_attributes to be a sub object but currently it's coming through
                          // with the double underscores so we'll comment this out for now.
                          //&& field.id.substring(0, 20) !== 'profile_attributes__'
                          <TableRow key={index}>
                                        <TableCell>
                                          <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                alignContent: 'center'
                              }}>
                                            <Typography variant="tableHeader">{field.name}</Typography>
                                          </Box>
                                        </TableCell>

                                        <TableCell>
                                          <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                alignContent: 'center'
                              }}>
                                            <Typography>{makeOverflowTooltip(formatField(field, fieldValue), 45)}</Typography>
                                          </Box>
                                        </TableCell>
                                      </TableRow> : <TableRow key={index}>
                                        <TableCell>
                                          <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                alignContent: 'center'
                              }}>
                                            <Typography variant="tableHeader">{field.name}</Typography>
                                          </Box>
                                        </TableCell>
                                        <TableCell>
                                          <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                alignContent: 'center'
                              }}>
                                            <Typography>
                                              {makeOverflowTooltip((() => {
                                    const keys = field.id.split('__');
                                    let rawValue;
                                    if (keys.length === 2 && keys[0] === 'entity_data') {
                                      rawValue = getCaseInsensitiveValue(customer.entity_data, keys[1]);
                                    } else if (keys.length === 2 && keys[0] === 'appended_data') {
                                      rawValue = getCaseInsensitiveValue(customer.appended_data, keys[1]);
                                    } else if (keys.length === 2 && keys[0] === 'profile_attributes') {
                                      rawValue = getCaseInsensitiveValue(customer.profile_attributes, keys[1]);
                                    } else {
                                      rawValue = getter(customer, keys);
                                    }
                                    return formatEntityDataField(field, rawValue);
                                  })(), 45)}
                                            </Typography>
                                          </Box>
                                        </TableCell>
                                      </TableRow>;
                        })}
                            </TableBody>
                          </Table>
                        </TableCell>
                      </TableRow>
                      {drawerSummary.hiddenCount > 0 && <TableRow sx={{
                  cursor: 'pointer'
                }} onClick={() => setShowMoreCustomerFields(!showMoreCustomerFields)}>
                          <TableCell sx={{
                    py: '8px'
                  }}>
                            <Typography sx={{
                      color: '#1D252D80'
                    }}>
                              {'... ' + drawerSummary.hiddenCount + (showMoreCustomerFields ? ' less items' : ' more items')}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{
                    py: '8px'
                  }}>
                            <Box className="d-flex  justify-content-between">
                              <span />
                              <Button>
                                <Stack sx={{
                          display: 'flex',
                          alignItems: 'center'
                        }} direction="row" spacing="10px">
                                  <Typography sx={{
                            color: '#3898D9',
                            textTransform: 'none',
                            whiteSpace: 'nowrap'
                          }}>
                                    {showMoreCustomerFields ? 'View less' : 'View all'}
                                  </Typography>
                                  {showMoreCustomerFields ? <CarrotUpIcon /> : <CarrotDownIcon />}
                                </Stack>
                              </Button>
                            </Box>
                          </TableCell>
                        </TableRow>}
                    </TableBody>
                  </Table>}
              </Stack>
            </Box>
            <Box sx={{
          borderTop: '1px solid #EDEFF1',
          borderBottom: '1px solid #EDEFF1'
        }}>
              <Stack spacing={'10px'} sx={{
            'pt': '28px',
            'pb': customerMatchingExpanded ? '0px' : '28px',
            'px': '24px',
            'display': 'flex',
            'alignItems': 'center',
            'alignContent': 'center',
            'cursor': 'pointer',
            'backgroundColor': customerMatchingExpanded ? '#F3F6FC' : '#ffffff',
            ':hover': {
              backgroundColor: '#F3F6FC'
            }
          }} onClick={() => setCustomerMatchingExpanded(!customerMatchingExpanded)}>
                <Box className="d-flex w-100 justify-content-between">
                  <Box sx={{
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center'
              }}>
                    {customerMatchingExpanded ? <JoinLeftIcon /> : <JoinInnerIcon />}
                    <Typography sx={{
                  pl: '16px'
                }} fontSize={'20px'}>
                      Customer Matching
                    </Typography>
                  </Box>
                  {customerMatchingExpanded ? <CarrotUpIcon /> : <CarrotDownIcon />}
                </Box>

                {customerMatchingExpanded && <Table sx={{
              cursor: 'default',
              tableLayout: 'fixed',
              width: '100%',
              ...(isMobile && {
                '& .MuiTypography-root': {
                  fontSize: '12px'
                }
              })
            }} onClick={e => e.stopPropagation()}>
                    <colgroup>
                      <col style={{
                  width: '25%'
                }} />
                      <col style={{
                  width: '25%'
                }} />
                      <col style={{
                  width: '25%'
                }} />
                      <col style={{
                  width: '25%'
                }} />
                    </colgroup>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{
                    pl: {
                      xs: '12px',
                      md: '40px'
                    },
                    pr: '10px'
                  }}>
                          <Typography variant="tableHeader"> Name </Typography>
                        </TableCell>
                        <TableCell sx={{
                    px: '0px'
                  }}>
                          <Typography variant="tableHeader"> Phone </Typography>
                        </TableCell>
                        <TableCell sx={{
                    px: '5px'
                  }}>
                          <Typography variant="tableHeader"> Email </Typography>
                        </TableCell>
                        <TableCell sx={{
                    px: '5px'
                  }}>
                          <Typography variant="tableHeader"> Source </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {customerDetails.customer_refs.filter((f, i) => showMoreCustomerRefs || i < 5).map((ref, index) => <TableRow key={ref.id} onClick={() => {
                  //go to new customer detail page
                }} onMouseEnter={() => {
                  setOnHover(ref.id);
                }} onMouseLeave={() => {
                  setOnHover(null);
                }} sx={{
                  'cursor': 'pointer',
                  ':hover': {
                    backgroundColor: '#ffffff'
                  }
                }}>
                            <TableCell sx={{
                    pl: {
                      xs: '12px',
                      md: '40px'
                    },
                    pr: '8px'
                  }} className={customerDetails.customer_refs.length < 4 && index === customerDetails.customer_refs.length - 1 ? 'hideBottom' : ''}>
                              <Tooltip title={<>
                                    {ref.first_name} {ref.last_name}
                                  </>}>
                                <Typography sx={{
                        display: ' inline-block',
                        width: '100%',
                        maxWidth: '130px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden !important',
                        textOverflow: 'ellipsis'
                      }}>
                                  {ref.first_name + ' ' + ref.last_name}
                                </Typography>
                              </Tooltip>
                            </TableCell>
                            {ref?.phone == '' || ref?.phone === null ? <TableCell sx={{
                    px: '8px'
                  }} className={customerDetails.customer_refs.length < 4 && index === customerDetails.customer_refs.length - 1 ? 'hideBottom' : ''}>
                                <Typography variant="nullData" color={'#BEBEBE'} sx={{
                      display: ' inline-block',
                      width: '100%',
                      maxWidth: '150px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden !important',
                      textOverflow: 'ellipsis',
                      alignContent: 'center',
                      alignItems: 'center'
                    }}>
                                  <span>--</span>{' '}
                                </Typography>
                              </TableCell> : <TableCell sx={{
                    px: '8px'
                  }} className={customerDetails.customer_refs.length < 4 && index === customerDetails.customer_refs.length - 1 ? 'hideBottom' : ''}>
                                <Typography sx={{
                      display: ' inline-block',
                      width: '100%',
                      maxWidth: '150px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden !important',
                      textOverflow: 'ellipsis'
                    }} component="div">
                                  <PhoneText>{utils.formatPhoneNumber(ref.phone)}</PhoneText>
                                </Typography>
                              </TableCell>}
                            <TableCell sx={{
                    px: '8px'
                  }} className={customerDetails.customer_refs.length < 4 && index === customerDetails.customer_refs.length - 1 ? 'hideBottom' : ''}>
                              {ref.email === '' || ref?.email == null ? <Typography variant="nullData" color={'#BEBEBE'} sx={{
                      display: ' inline-block',
                      width: '100%',
                      maxWidth: '150px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden !important',
                      textOverflow: 'ellipsis'
                    }}>
                                  <span>--</span>{' '}
                                </Typography> : <Tooltip title={ref.email}>
                                  <Typography sx={{
                        display: ' inline-block',
                        width: '100%',
                        maxWidth: '130px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden !important',
                        textOverflow: 'ellipsis'
                      }}>
                                    {ref.email}
                                  </Typography>
                                </Tooltip>}
                            </TableCell>

                            <TableCell sx={{
                    pl: '8px',
                    pr: '8px'
                  }} className={customerDetails.customer_refs.length < 4 && index === customerDetails.customer_refs.length - 1 ? 'hideBottom' : ''}>
                              <Stack direction="row" sx={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      alignContent: 'center',
                      overflow: 'hidden'
                    }}>
                                <Tooltip title={ref?.entity_source}>
                                  <Typography sx={{
                          display: ' inline-block',
                          maxWidth: '80px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden !important',
                          textOverflow: 'ellipsis',
                          flexShrink: 1
                        }}>
                                    {ref?.entity_source}
                                  </Typography>
                                </Tooltip>

                                {onHover == ref.id && <Stack spacing="5px" direction="row" sx={{
                        position: 'absolute',
                        right: '0px'
                      }}>
                                    {flags.split_customer && customerDetails.customer_refs.length > 1 && <Tooltip title="Split into new customer record">
                                        <IconButton onClick={e => {
                            e.stopPropagation();
                            handleSplitCustomerRef(ref.id);
                          }} size="small">
                                          <EjectIcon fill="#1D252D" />
                                        </IconButton>
                                      </Tooltip>}
                                  </Stack>}
                              </Stack>
                            </TableCell>
                          </TableRow>)}

                      {!customerDetails.customer_refs.length && <TableRow>
                          <TableCell sx={{
                    px: '40px'
                  }} className="hideBottom" colSpan={4}>
                            <Typography> Customer has no matching data</Typography>
                          </TableCell>
                        </TableRow>}

                      {customerDetails.customer_refs.length > 5 && <TableRow>
                          <TableCell colSpan={3} sx={{
                    px: '40px',
                    p: 1,
                    borderBottom: 0
                  }}>
                            <Button tag="a" onClick={() => setShowMoreCustomerRefs(!showMoreCustomerRefs)}>
                              <MoreHorizontalIcon />
                              <Typography sx={{
                        color: '#1D252D80',
                        textTransform: 'none'
                      }}>
                                {showMoreCustomerRefs ? 'Show Less' : 'Show ' + (customerDetails.customer_refs.length - 5) + ' more item(s)'}
                              </Typography>
                            </Button>
                          </TableCell>

                          <TableCell colSpan={1} sx={{
                    px: '40px',
                    p: 1,
                    borderBottom: 0
                  }}>
                            <Button tag="a">
                              <Typography sx={{
                        color: '#3898D9',
                        textTransform: 'none',
                        whiteSpace: 'nowrap'
                      }}>View all</Typography>
                              <OpenInNewWindowIcon fill="#3898D9" />
                            </Button>
                          </TableCell>
                        </TableRow>}
                    </TableBody>
                  </Table>}
              </Stack>
            </Box>
            <Box sx={{
          borderTop: '1px solid #EDEFF1',
          borderBottom: '1px solid #EDEFF1'
        }}>
              <Stack spacing={'10px'} sx={{
            'pt': '28px',
            'pb': staticSegmentExpanded ? '0px' : '28px',
            'px': '24px',
            'display': 'flex',
            'alignItems': 'center',
            'alignContent': 'center',
            'cursor': 'pointer',
            'backgroundColor': staticSegmentExpanded ? '#F3F6FC' : '#ffffff',
            ':hover': {
              backgroundColor: '#F3F6FC'
            }
          }} onClick={() => setStaticSegmentExpanded(!staticSegmentExpanded)}>
                <Box className="d-flex w-100 justify-content-between ">
                  <Box sx={{
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center'
              }}>
                    <SegmentIcon />
                    <Typography sx={{
                  pl: '16px'
                }} fontSize={'20px'}>
                      Static Segments
                    </Typography>
                  </Box>
                  <Box>
                    {hasPermission('customer.add_segment') && <Tooltip title="Add to Static Segment">
                        <IconButton onClick={e => {
                    setShowModal(true);
                    e.stopPropagation();
                  }}>
                          <AddCircleFilledIcon />
                        </IconButton>
                      </Tooltip>}
                    {staticSegmentExpanded ? <CarrotUpIcon /> : <CarrotDownIcon />}
                  </Box>
                </Box>
                {staticSegmentExpanded && <Table sx={{
              cursor: 'default'
            }} onClick={e => e.stopPropagation()}>
                    <colgroup>
                      <col style={{
                  width: '50%'
                }} />
                      <col style={{
                  width: '50%'
                }} />
                    </colgroup>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{
                    px: '40px'
                  }}>
                          <Typography variant="tableHeader">Segment </Typography>
                        </TableCell>
                        <TableCell sx={{
                    pl: '56px',
                    pr: '8px'
                  }}>
                          <Typography variant="tableHeader">Date Added </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {customerDetails.segments.filter((f, i) => showMoreSegments || i < 5).map((ref, index) => <TableRow key={ref.id} onClick={() => {
                  window.open(`/segments/${ref.segment_id}`);
                }} onMouseEnter={() => {
                  setOnHover(ref.id);
                }} onMouseLeave={() => {
                  setOnHover(null);
                }} sx={{
                  'cursor': 'pointer',
                  ':hover': {
                    backgroundColor: '#ffffff'
                  }
                }}>
                            <TableCell sx={{
                    px: '40px'
                  }} className={customerDetails.segments.length < 4 && index === customerDetails.segments.length - 1 ? 'hideBottom' : ''}>
                              <Tooltip title={ref.segment_name}>
                                <Typography sx={{
                        display: ' inline-block',
                        width: '275px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden !important',
                        textOverflow: 'ellipsis'
                      }}>
                                  {ref.segment_name}
                                </Typography>
                              </Tooltip>
                            </TableCell>

                            <TableCell sx={{
                    pl: '56px',
                    pr: '8px',
                    py: '12px'
                  }} className={customerDetails.segments.length < 4 && index === customerDetails.segments.length - 1 ? 'hideBottom' : ''} colSpan={6}>
                              <Stack direction="row" sx={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      alignContent: 'center',
                      overflow: 'visible',
                      minHeight: '40px'
                    }}>
                                <Typography> {moment(ref.segment_date).format('MMM D, YYYY')}</Typography>

                                {onHover == ref.id && <Stack spacing="5px" direction="row" sx={{
                        position: 'absolute',
                        right: '0px',
                        zIndex: 10
                      }}>
                                    {hasPermission('customer.delete_segment') && <Tooltip title="Remove from Static Segment">
                                        <IconButton onClick={e => {
                            e.stopPropagation();
                            setRemoveCustomerModal(ref);
                          }} sx={{
                            p: '6px'
                          }}>
                                          <CancelIcon fill="#1D252D" />
                                        </IconButton>
                                      </Tooltip>}

                                    {hasPermission('customer.view_segment') && <Tooltip title="View this segment in a new tab">
                                        <IconButton onClick={e => {
                            e.stopPropagation();
                            window.open(`/segments/${ref.segment_id}`);
                          }} sx={{
                            p: '6px'
                          }}>
                                          <OpenInNewWindowIcon fill="#1D252D" />
                                        </IconButton>
                                      </Tooltip>}
                                  </Stack>}
                              </Stack>
                            </TableCell>
                          </TableRow>)}

                      {!customerDetails.segments.length && <TableRow>
                          <TableCell sx={{
                    px: '40px'
                  }} className="hideBottom" colSpan={4}>
                            <Typography> Customer is not in any segments</Typography>
                          </TableCell>
                        </TableRow>}

                      {customerDetails.segments.length > 5 && <TableRow>
                          <TableCell colSpan={3} sx={{
                    p: 1,
                    borderBottom: 0
                  }}>
                            <Button tag="a" onClick={() => setShowMoreSegments(!showMoreSegments)}>
                              <MoreHorizontalIcon />
                              <Typography sx={{
                        color: '#1D252D80',
                        textTransform: 'none'
                      }}>
                                {showMoreSegments ? 'Show Less' : 'Show ' + (customerDetails.segments.length - 5) + ' more item(s)'}
                              </Typography>
                            </Button>
                          </TableCell>
                        </TableRow>}
                    </TableBody>
                  </Table>}
              </Stack>
            </Box>

            {customerDetails.vehicles?.some(v => flags['retire-vehicles'] || !v.deleted_when) && <>
                <Box sx={{
            borderTop: '1px solid #EDEFF1',
            borderBottom: '1px solid #EDEFF1'
          }}>
                  <Stack spacing={'10px'} sx={{
              'pt': '28px',
              'pb': vehiclesExpanded ? '0px' : '28px',
              'px': '24px',
              'display': 'flex',
              'alignItems': 'center',
              'alignContent': 'center',
              'cursor': 'pointer',
              'backgroundColor': vehiclesExpanded ? '#F3F6FC' : '#ffffff',
              ':hover': {
                backgroundColor: '#F3F6FC'
              }
            }} onClick={() => setVehiclesExpanded(!vehiclesExpanded)}>
                    <Box className="d-flex w-100 justify-content-between">
                      <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  alignContent: 'center'
                }}>
                        {vehiclesExpanded ? <VehicleFilledIcon /> : <VehicleIcon />}
                        <Typography sx={{
                    pl: '16px'
                  }} fontSize={'20px'}>
                          Vehicles
                        </Typography>
                      </Box>
                      <Box>{vehiclesExpanded ? <CarrotUpIcon /> : <CarrotDownIcon />}</Box>
                    </Box>
                    {vehiclesExpanded && <Table sx={{
                cursor: 'default'
              }} onClick={e => e.stopPropagation()}>
                        <colgroup>
                          <col style={{
                    width: '42%'
                  }} />
                          <col style={{
                    width: '22%'
                  }} />
                          <col style={{
                    width: '24%'
                  }} />
                          <col style={{
                    width: '12%'
                  }} />
                        </colgroup>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{
                      pl: '40px'
                    }}>
                              <Typography variant="tableHeader">Vehicle</Typography>
                            </TableCell>
                            <TableCell>
                              <Typography sx={{
                        p: 0
                      }} variant="tableHeader">
                                VIN
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography sx={{
                        p: 0
                      }} variant="tableHeader">
                                Tags
                              </Typography>
                            </TableCell>
                            <TableCell />
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(() => {
                    const groups = {};
                    (customerDetails.vehicles || []).forEach(sv => {
                      const key = sv.matching_vehicle?.id || `unmatched_${sv.id}`;
                      if (!groups[key]) {
                        groups[key] = {
                          matching_vehicle: sv.matching_vehicle || null,
                          source_vehicles: []
                        };
                      }
                      groups[key].source_vehicles.push(sv);
                    });
                    const allGroups = Object.values(groups);
                    const activeGroups = allGroups.filter(g => !g.source_vehicles.every(sv => !!sv.deleted_when));
                    const removedGroups = allGroups.filter(g => g.source_vehicles.every(sv => !!sv.deleted_when));
                    const renderRow = (group, opts = {}) => {
                      const {
                        isRemoved = false
                      } = opts;
                      const mv = group.matching_vehicle;
                      const sv0 = group.source_vehicles[0];
                      const year = mv?.year ?? sv0?.year;
                      const make = mv?.make ?? sv0?.make;
                      const model = mv?.model ?? sv0?.model;
                      const vin = mv?.vin ?? sv0?.vin;
                      const tag = mv?.tag ?? sv0?.tag;
                      const tagState = mv?.tag_state ?? sv0?.tag_state;
                      const tagDisplay = tagState && tag ? `${tagState} - ${tag}` : tag || tagState || '--';
                      const groupKey = mv?.id || sv0?.id;
                      const vehicleRef = mv ? {
                        company_vehicle_id: mv.id
                      } : {
                        vehicle_id: sv0.id
                      };
                      return <TableRow key={groupKey} onMouseEnter={() => setOnHover(groupKey)} onMouseLeave={() => setOnHover(null)} sx={{
                        ':hover': {
                          backgroundColor: '#F9FAFB'
                        }
                      }}>
                                  <TableCell sx={{
                          pl: '40px',
                          pr: '10px',
                          color: isRemoved ? '#d3d3d3' : undefined
                        }}>
                                    <Typography sx={{
                            color: isRemoved ? '#d3d3d3' : undefined
                          }}>
                                      {makeOverflowTooltip([year, make, model].filter(Boolean).join(' ') || '--', 30)}
                                    </Typography>
                                  </TableCell>
                                  <TableCell sx={{
                          pl: '16px',
                          pr: '10px',
                          color: isRemoved ? '#d3d3d3' : undefined
                        }}>
                                    <Typography sx={{
                            color: isRemoved ? '#d3d3d3' : undefined
                          }}>{vin || '--'}</Typography>
                                  </TableCell>
                                  <TableCell sx={{
                          pl: '16px',
                          pr: '0px',
                          color: isRemoved ? '#d3d3d3' : undefined
                        }}>
                                    <Typography sx={{
                            color: isRemoved ? '#d3d3d3' : undefined
                          }}>{tagDisplay}</Typography>
                                  </TableCell>
                                  <TableCell sx={{
                          pr: '8px',
                          py: '0px'
                        }}>
                                    {onHover === groupKey && <Stack direction="row" spacing="4px" alignItems="center">
                                        {!isRemoved && goToVehicle && <Tooltip title="View vehicle details">
                                            <IconButton size="small" onClick={e => {
                                e.stopPropagation();
                                goToVehicle(groupKey);
                              }}>
                                              <OpenInNewWindowIcon fill="#1D252D" />
                                            </IconButton>
                                          </Tooltip>}
                                        {!isRemoved && vehicleRef && flags['retire-vehicles'] && <Tooltip title="Retire vehicle">
                                            <IconButton size="small" onClick={e => {
                                e.stopPropagation();
                                setVehicleActionModal({
                                  type: 'remove',
                                  ref: vehicleRef
                                });
                              }}>
                                              <DeleteIcon />
                                            </IconButton>
                                          </Tooltip>}
                                        {isRemoved && vehicleRef && <Tooltip title="Restore vehicle">
                                            <IconButton size="small" onClick={e => {
                                e.stopPropagation();
                                setVehicleActionModal({
                                  type: 'restore',
                                  ref: vehicleRef
                                });
                              }}>
                                              <UndoIcon />
                                            </IconButton>
                                          </Tooltip>}
                                      </Stack>}
                                  </TableCell>
                                </TableRow>;
                    };
                    return <>
                                {activeGroups.filter((_, i) => showMoreVehicles || i < 5).map(g => renderRow(g))}
                                {activeGroups.length > 5 && <TableRow>
                                    <TableCell colSpan={4} sx={{
                          p: 1,
                          borderBottom: 0
                        }}>
                                      <Button tag="a" onClick={() => setShowMoreVehicles(!showMoreVehicles)}>
                                        <MoreHorizontalIcon />
                                        <Typography sx={{
                              color: '#1D252D80',
                              textTransform: 'none'
                            }}>
                                          {showMoreVehicles ? 'Show Less' : `Show ${activeGroups.length - 5} more item(s)`}
                                        </Typography>
                                      </Button>
                                    </TableCell>
                                  </TableRow>}
                                {flags['retire-vehicles'] && removedGroups.length > 0 && <TableRow>
                                    <TableCell colSpan={4} sx={{
                          p: 1,
                          borderBottom: 0
                        }}>
                                      <Button tag="a" onClick={() => setShowRemovedVehicles(!showRemovedVehicles)}>
                                        <MoreHorizontalIcon />
                                        <Typography sx={{
                              color: '#1D252D80',
                              textTransform: 'none'
                            }}>
                                          {showRemovedVehicles ? 'Hide retired vehicles' : `Show retired vehicles (${removedGroups.length})`}
                                        </Typography>
                                      </Button>
                                    </TableCell>
                                  </TableRow>}
                                {flags['retire-vehicles'] && showRemovedVehicles && removedGroups.map(g => renderRow(g, {
                        isRemoved: true
                      }))}
                              </>;
                  })()}
                        </TableBody>
                      </Table>}
                  </Stack>
                </Box>
              </>}

            {customerDetails.animals?.length > 0 && <>
                <Box sx={{
            borderTop: '1px solid #EDEFF1',
            borderBottom: '1px solid #EDEFF1'
          }}>
                  <Stack spacing={'10px'} sx={{
              'pt': '28px',
              'pb': animalsExpanded ? '0px' : '28px',
              'px': '24px',
              'display': 'flex',
              'alignItems': 'center',
              'alignContent': 'center',
              'cursor': 'pointer',
              'backgroundColor': animalsExpanded ? '#F3F6FC' : '#ffffff',
              ':hover': {
                backgroundColor: '#F3F6FC'
              }
            }} onClick={() => setAnimalsExpanded(!animalsExpanded)}>
                    <Box className="d-flex w-100 justify-content-between">
                      <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  alignContent: 'center'
                }}>
                        <Icon name="custom-pets" size={24} />
                        <Typography sx={{
                    pl: '16px'
                  }} fontSize={'20px'}>
                          Animals
                        </Typography>
                      </Box>
                      <Box>{animalsExpanded ? <CarrotUpIcon /> : <CarrotDownIcon />}</Box>
                    </Box>
                    {animalsExpanded && <Table sx={{
                cursor: 'default'
              }} onClick={e => e.stopPropagation()}>
                        <colgroup>
                          <col style={{
                    width: '50%'
                  }} />
                          <col style={{
                    width: '25%'
                  }} />
                          <col style={{
                    width: '25%'
                  }} />
                        </colgroup>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{
                      pl: '40px'
                    }}>
                              <Typography variant="tableHeader">Name </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography sx={{
                        p: 0
                      }} variant="tableHeader">
                                Breed
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography sx={{
                        p: 0
                      }} variant="tableHeader">
                                Species
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {customerDetails.animals.filter((f, i) => showMoreAnimals || i < 5).map((animal, index) => {
                    return <TableRow key={animal.id} sx={{
                      color: '#d3d3d3'
                    }}>
                                  <TableCell sx={{
                        pl: '40px',
                        pr: '10px'
                      }} className={customerDetails.animals.length < 4 && index === customerDetails.animals.length - 1 ? 'hideBottom' : ''}>
                                    {animal.name}
                                  </TableCell>

                                  <TableCell sx={{
                        pl: '16px',
                        pr: '10px'
                      }} className={customerDetails.animals.length < 4 && index === customerDetails.animals.length - 1 ? 'hideBottom' : ''}>
                                    {animal.color || ''} {animal.breed || ''}
                                  </TableCell>

                                  <TableCell sx={{
                        pl: '16px',
                        pr: '10px'
                      }} className={customerDetails.animals.length < 4 && index === customerDetails.animals.length - 1 ? 'hideBottom' : ''}>
                                    {animal.species || ''}
                                  </TableCell>
                                </TableRow>;
                  })}

                          {!customerDetails.animals.length && <TableRow>
                              <TableCell className="hideBottom" colSpan={4}>
                                <Typography> Customer does not have any animals</Typography>
                              </TableCell>
                            </TableRow>}

                          {customerDetails.animals.length > 5 && <TableRow>
                              <TableCell colSpan={3} sx={{
                      p: 1,
                      borderBottom: 0
                    }}>
                                <Button tag="a" onClick={() => setShowMoreAnimals(!showMoreAnimals)}>
                                  <MoreHorizontalIcon />
                                  <Typography sx={{
                          color: '#1D252D80',
                          textTransform: 'none'
                        }}>
                                    {showMoreAnimals ? 'Show Less' : 'Show ' + (customerDetails.animals.length - 5) + ' more item(s)'}
                                  </Typography>
                                </Button>
                              </TableCell>
                            </TableRow>}
                        </TableBody>
                      </Table>}
                  </Stack>
                </Box>
              </>}

            {customerDetails.subscriptions?.length > 0 && <Box sx={{
          borderTop: '1px solid #EDEFF1',
          borderBottom: '1px solid #EDEFF1'
        }}>
                <Stack spacing={'10px'} sx={{
            'pt': '28px',
            'pb': subscriptionExpanded ? '0px' : '28px',
            'px': '24px',
            'display': 'flex',
            'alignItems': 'center',
            'alignContent': 'center',
            'wordWrap': 'break-word',
            'cursor': 'pointer',
            'backgroundColor': subscriptionExpanded ? '#F3F6FC' : '#ffffff',
            ':hover': {
              backgroundColor: '#F3F6FC'
            }
          }} onClick={() => setSubscriptionExpanded(!subscriptionExpanded)}>
                  <Box className="d-flex w-100 justify-content-between">
                    <Box sx={{
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center'
              }}>
                      {subscriptionExpanded ? <SubscriptionsFilledIcon /> : <SubscriptionsIcon />}

                      <Typography sx={{
                  pl: '16px'
                }} fontSize={'20px'}>
                        Subscriptions
                      </Typography>
                    </Box>
                    <Box>{subscriptionExpanded ? <CarrotUpIcon /> : <CarrotDownIcon />}</Box>
                  </Box>

                  {subscriptionExpanded && <Table sx={{
              cursor: 'default'
            }} onClick={e => e.stopPropagation()}>
                      <colgroup>
                        <col style={{
                  width: '20%'
                }} />
                        <col style={{
                  width: '35%'
                }} />
                        <col style={{
                  width: '35%'
                }} />
                        <col style={{
                  width: '10%'
                }} />
                      </colgroup>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{
                    px: '40px'
                  }}>
                            <Typography variant="tableHeader">Name </Typography>
                          </TableCell>
                          <TableCell sx={{
                    px: '40px'
                  }}>
                            <Typography variant="tableHeader">Start Date </Typography>
                          </TableCell>
                          <TableCell sx={{
                    px: '40px'
                  }}>
                            <Typography variant="tableHeader">End Date </Typography>
                          </TableCell>
                          <TableCell sx={{
                    px: '40px'
                  }}>
                            <Typography variant="tableHeader">Status </Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {customerDetails.subscriptions.filter((f, i) => showMoreSubscriptions || i < 5).map((ref, index) => <TableRow key={ref.id} onMouseEnter={() => {
                  setOnHover(ref.id);
                }} onMouseLeave={() => {
                  setOnHover(null);
                }} sx={{
                  'cursor': 'pointer',
                  ':hover': {
                    backgroundColor: '#ffffff'
                  }
                }}>
                              <TableCell sx={{
                    px: '40px'
                  }} className={customerDetails.subscriptions.length < 4 && index === customerDetails.subscriptions.length - 1 ? 'hideBottom' : ''}>
                                <Typography>{makeOverflowTooltip(ref.name, 11)}</Typography>
                              </TableCell>

                              <TableCell sx={{
                    px: '40px'
                  }} className={customerDetails.subscriptions.length < 4 && index === customerDetails.subscriptions.length - 1 ? 'hideBottom' : ''}>
                                {moment(ref.start_when).format('MMM D, YYYY')}
                              </TableCell>

                              <TableCell sx={{
                    px: '40px'
                  }} className={customerDetails.subscriptions.length < 4 && index === customerDetails.subscriptions.length - 1 ? 'hideBottom' : ''}>
                                {moment(ref.end_when).format('MMM D, YYYY')}
                              </TableCell>

                              <TableCell sx={{
                    px: '40px'
                  }} className={customerDetails.subscriptions.length < 4 && index === customerDetails.subscriptions.length - 1 ? 'hideBottom' : ''}>
                                <Stack spacing="10px" direction="row" sx={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      alignContent: 'center'
                    }}>
                                  <Typography>{ref.status}</Typography>

                                  {/* {onHover == ref.id && (
                                   <Tooltip sx={{ position: 'absolute', left: '1px' }} title="View this subscription in a new tab">
                                    <IconButton
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        // window.open(`/segments/${ref.segment_id}`);
                                      }}
                                    >
                                      <OpenInNewWindowIcon fill="#1D252D" />
                                    </IconButton>
                                   </Tooltip>
                                   )} */}
                                </Stack>
                              </TableCell>
                            </TableRow>)}
                        {!customerDetails.subscriptions.length && <TableRow>
                            <TableCell className="hideBottom" colSpan={4}>
                              <Typography> Customer does not have any subscriptions</Typography>
                            </TableCell>
                          </TableRow>}

                        {customerDetails.subscriptions.length > 5 && <TableRow>
                            <TableCell colSpan={3} sx={{
                    p: 1,
                    borderBottom: 0
                  }}>
                              <Button tag="a" onClick={() => setShowMoreSubscriptions(!showMoreSubscriptions)}>
                                <MoreHorizontalIcon />
                                <Typography sx={{
                        color: '#1D252D80',
                        textTransform: 'none'
                      }}>
                                  {showMoreSubscriptions ? 'Show Less' : 'Show ' + (customerDetails.subscriptions.length - 5) + ' more item(s)'}
                                </Typography>
                              </Button>
                            </TableCell>
                          </TableRow>}
                      </TableBody>
                    </Table>}
                </Stack>
              </Box>}

            {/* Notes is deliberately last and renders even with zero notes, so there is always a place to add one. */}
            {showNotes && <Box sx={{
          borderTop: '1px solid #EDEFF1',
          borderBottom: '1px solid #EDEFF1'
        }}>
                <Stack spacing={'10px'} sx={{
            'pt': '28px',
            'pb': notesExpanded ? '24px' : '28px',
            'px': '24px',
            'display': 'flex',
            'alignItems': 'center',
            'alignContent': 'center',
            'cursor': 'pointer',
            'backgroundColor': notesExpanded ? '#F3F6FC' : '#ffffff',
            ':hover': {
              backgroundColor: '#F3F6FC'
            }
          }} onClick={() => setNotesExpanded(!notesExpanded)}>
                  <Box className="d-flex w-100 justify-content-between">
                    <Box sx={{
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center'
              }}>
                      {notesExpanded ? <NotesFilledIcon /> : <NotesIcon />}
                      <Typography sx={{
                  pl: '16px'
                }} fontSize={'20px'}>
                        {customerNotes.notes?.length > 0 ? `Notes (${customerNotes.notes.length})` : 'Notes'}
                      </Typography>
                    </Box>
                    <Box>
                      {hasPermission('notes.add_note') && <Tooltip title="Add Note">
                          <IconButton onClick={e => {
                    e.stopPropagation();
                    setNotesExpanded(true);
                    customerNotes.startAdding();
                  }}>
                            <AddCircleFilledIcon />
                          </IconButton>
                        </Tooltip>}
                      {notesExpanded ? <CarrotUpIcon /> : <CarrotDownIcon />}
                    </Box>
                  </Box>

                  {notesExpanded && <Box sx={{
              width: '100%',
              cursor: 'default',
              px: '16px'
            }} onClick={e => e.stopPropagation()}>
                      {/* White cards: the default #F9FBFD disappears against the expanded #F3F6FC background. */}
                      <CinchNotesList notesApi={customerNotes} canEdit={hasPermission('notes.change_note')} canDelete={hasPermission('notes.delete_note')} onDeleteRequest={setNoteToDelete} cardBackground="#ffffff" />
                    </Box>}
                </Stack>
              </Box>}
          </Stack>
          <Box sx={{
        borderTop: '1px solid #EDEFF1',
        display: 'flex',
        justifyContent: 'flex-end',
        p: '30px'
      }}>
            {/* CIN-7047: "Create task for customer", bottom-left of the footer. Its
                auto right margin pushes it left while Expand All stays right, so the
                footer line above is untouched (the CIN-7090 Notes branch edits the
                lines around it). Renders nothing without the Task Manager. */}
            <DrawerCreateTaskButton customer={customer} onCreated={props.onTaskCreated} sx={{
          mr: 'auto'
        }} />
            <Button onClick={() => {
          handleExpandAllClick();
        }}>
              {expandAll ? <Typography sx={{
            color: '#3898D9',
            textTransform: 'none'
          }}>
                  Collapse All <DoubleCarrotUpIcon />
                </Typography> : <Typography sx={{
            color: '#3898D9',
            textTransform: 'none'
          }}>
                  Expand All <DoubleCarrotDownIcon />
                </Typography>}
            </Button>
          </Box>
        </Stack>}
      <Popper anchorEl={optStatusMenuAnchorEl} sx={{
      zIndex: 9001
    }} open={!!optStatusMenu} onClose={handleOptStatusMenuClose} placement="bottom">
        <ClickAwayListener onClickAway={handleOptStatusMenuClose}>
          <Paper elevation={0} sx={{
          borderRadius: '16px',
          overflow: 'visible',
          filter: 'drop-shadow(0px 0px 4px rgba(0,0,0,0.25))'
        }}>
            <Box sx={{
            py: 1
          }}>
              <Box display="flex" flexDirection="column">
                {optStatusMenu == 'sms' && customerDetails.sms_optstatus != 'opt_out' && <Button onClick={() => {
                handleOptStatusMenuClose();
                setShowOptOutSMS(true);
              }} variant="text" fullWidth sx={{
                cursor: 'pointer',
                height: '48px',
                color: '#1D252D',
                textTransform: 'none',
                justifyContent: 'flex-start',
                px: 2
              }}>
                    <StatusDotIcon fill={'#F30F0F'} />
                    <Typography sx={{
                  textTransform: 'none',
                  whiteSpace: 'nowrap'
                }}>Opt out</Typography>
                  </Button>}

                {optStatusMenu == 'email' && customerDetails.email_optstatus != 'unsubscribed' && <Button onClick={() => {
                handleOptStatusMenuClose();
                unsubscribeCustomer('unsubscribed');
              }} variant="text" fullWidth sx={{
                cursor: 'pointer',
                height: '48px',
                color: '#1D252D',
                textTransform: 'none',
                justifyContent: 'flex-start',
                px: 2
              }}>
                    <StatusDotIcon fill={'#F30F0F'} />
                    <Typography sx={{
                  textTransform: 'none',
                  whiteSpace: 'nowrap'
                }}>Unsubscribe</Typography>
                  </Button>}

                <Button onClick={() => {
                handleOptStatusMenuClose();
                optStatusMenu == 'email' ? unsubscribeCustomer('pending') : resubscribeSMS();
              }} variant="text" fullWidth sx={{
                cursor: 'pointer',
                height: '48px',
                color: '#1D252D',
                textTransform: 'none',
                justifyContent: 'flex-start',
                px: 2
              }}>
                  <StatusDotIcon fill={'#F30F0F'} />
                  <Typography sx={{
                  textTransform: 'none',
                  whiteSpace: 'nowrap'
                }}>Reset Status</Typography>
                </Button>
              </Box>
            </Box>
          </Paper>
        </ClickAwayListener>
      </Popper>

      {callModal && <CallModal open={!!callModal} onClose={() => setCallModal(null)} phone={callModal.phone} name={callModal.name} />}

      <CinchDialog open={showModal} onClose={() => setShowModal(false)} title="Add Customer to Static Segment" customWidth="420px" customHeight="auto" disableEnforceFocus bodyData={<>
            <p>Select the static segment</p>
            <div className="form-group">
              <DynamicTypeAhead getItems={getSegments} getItemsFilters={{
          time_dynamic_segment: false,
          company: asCompany.id,
          id_not_in: customerDetails?.segments?.map(s => s.segment_id).join(',')
        }} placeholder="Choose Customer Segment" displayProperty="name" keyProperty="id" value={selectedSegment} onChange={val => setSelectedSegment(val)} />
            </div>
          </>} actions={<div style={{
      display: 'flex',
      gap: '10px',
      justifyContent: 'flex-end'
    }}>
            <Button actionType="flat" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button actionType="primary" onClick={() => addCustomerToSegment()} disabled={!selectedSegment}>
              Add
            </Button>
          </div>} />

      <CinchDialog open={!!noteToDelete} size="auto" actionSize="large" onClose={() => setNoteToDelete(null)} title="Delete Note" onSubmit={() => {
      customerNotes.handleDeleteNote(noteToDelete.id);
      setNoteToDelete(null);
    }} bodyText="Are you sure you want to delete this note? This can't be undone from the drawer." />

      <CinchDialog open={showOptOutSMS} size="auto" actionSize="large" onClose={() => setShowOptOutSMS(false)} title="Opt Status Warning" onSubmit={() => {
      unsubscribeCustomerSMS();
      setShowOptOutSMS(false);
    }} bodyText='You are about to opt this phone number out from receiving text messages. The only way to have this phone number opt-in will be to
        have them text "START" to your phone number.' />

      <CinchDialog open={cantOptInSMS} size="auto" actionSize="large" onClose={() => setCantOptInSMS(false)} title="Reset SMS Status Warning" actions={<Box sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%'
    }}>
            <CinchActionButton onClick={() => setCantOptInSMS(false)} actionType="primary" text="Okay" />
          </Box>} bodyText='Because this phone number has opted out of text messages, you cannot opt them in. They can opt themselves back in to your text
          message by texting "START" to your phone number.' />

      <CinchDialog open={!!removeCustomerModal} onClose={() => setRemoveCustomerModal(null)} title="Remove Customer" customWidth="580px" customHeight="auto" bodyData={<p>{'Are you sure you want to remove this customer from segment ' + removeCustomerModal?.segment_name + '?'} </p>} actions={<div style={{
      display: 'flex',
      gap: '10px',
      justifyContent: 'flex-end'
    }}>
            <Button onClick={() => setRemoveCustomerModal(null)}>Cancel</Button>
            <Button onClick={() => {
        deleteSegment(removeCustomerModal.id);
        setRemoveCustomerModal(null);
      }}>
              Remove Customer
            </Button>
          </div>} />
      <CinchDialog open={!!vehicleActionModal} onClose={closeVehicleActionModal} title={vehicleActionModal?.type === 'remove' ? 'Retire vehicle?' : 'Restore vehicle?'} customWidth="440px" customHeight="auto" bodyData={<DialogContentText>
            {vehicleActionModal?.type === 'remove' ? 'Retiring this vehicle will eject the customer from any active segments and journey sessions tied to it. Segments and journey sessions are not restored if the vehicle is later un-retired.' : 'This will restore the vehicle and possession records for this customer.'}
          </DialogContentText>} actions={<div style={{
      display: 'flex',
      gap: '10px',
      justifyContent: 'flex-end'
    }}>
            <Button onClick={closeVehicleActionModal}>Cancel</Button>
            <Button onClick={confirmVehicleAction}>{vehicleActionModal?.type === 'remove' ? 'Retire' : 'Restore'}</Button>
          </div>} />

      {/* Split Customer Reference Preview Modal */}
      {flags.split_customer && <CinchDialog zIndex={1310} size="lg" customHeight="auto" open={showSplitModal} onClose={closeSplitModal} title="Split Customer" bodyData={<div className="modal__body">
            <p style={{
        marginBottom: '20px',
        fontSize: '14px',
        lineHeight: '1.4'
      }}>
              This will split off a new customer from this customer. All of the customer communications history will stay with the current
              customer (so all the emails, sms, mailers, journeys, etc.). Are you sure you want to split off this customer record?
            </p>

            {isLoadingSplitPreview ? <Loader sx={{
        p: 3
      }} /> : splitPreviewData ? <Box sx={{
        mt: 2
      }}>
                <Box sx={{
          display: 'flex',
          gap: 4
        }}>
                  {/* Original Customer */}
                  <Box sx={{
            flex: 1,
            border: '1px solid #EDEFF1',
            borderRadius: '8px',
            overflow: 'hidden'
          }}>
                    <Box sx={{
              backgroundColor: '#F3F6FC',
              p: 2,
              borderBottom: '1px solid #EDEFF1'
            }}>
                      <Typography fontSize={'18px'} fontWeight={'600'}>
                        Current Customer Preview
                      </Typography>
                    </Box>
                    <Box sx={{
              p: 2
            }}>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{
                      border: 0,
                      py: 1,
                      px: 0
                    }}>
                              <Typography variant="tableHeader" sx={{
                        fontSize: '16px',
                        fontWeight: 'bold'
                      }}>
                                {splitPreviewData.preview?.original_customer?.first_name}{' '}
                                {splitPreviewData.preview?.original_customer?.last_name}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{
                      border: 0,
                      py: 1,
                      px: 0
                    }}>
                              <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center'
                      }}>
                                <CallFilledIcon />
                                <Typography sx={{
                          pl: '10px'
                        }}>
                                  {splitPreviewData.preview?.original_customer?.phone || 'No Phone Number'}
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{
                      border: 0,
                      py: 1,
                      px: 0
                    }}>
                              <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center'
                      }}>
                                <MailEnvelopeFilledIcon size="sm" />
                                <Typography sx={{
                          pl: '10px'
                        }}>
                                  {splitPreviewData.preview?.original_customer?.email || 'No Email'}
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{
                      border: 0,
                      py: 1,
                      px: 0
                    }}>
                              <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center'
                      }}>
                                <LocationOnFilledIcon />
                                {!splitPreviewData.preview?.original_customer?.address1 && !splitPreviewData.preview?.original_customer?.address2 && !splitPreviewData.preview?.original_customer?.city && !splitPreviewData.preview?.original_customer?.state && !splitPreviewData.preview?.original_customer?.zip_code ? <Typography sx={{
                          pl: '10px'
                        }}>No Address</Typography> : <Typography sx={{
                          pl: '10px'
                        }}>
                                    {[[splitPreviewData.preview?.original_customer?.address1, splitPreviewData.preview?.original_customer?.address2].filter(Boolean).join(' '), [splitPreviewData.preview?.original_customer?.city, splitPreviewData.preview?.original_customer?.state].filter(Boolean).join(', '), splitPreviewData.preview?.original_customer?.zip_code].filter(Boolean).join(' ')}
                                  </Typography>}
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>

                      <Typography variant="tableHeader" sx={{
                mt: 2,
                mb: 1
              }}>
                        Customer References Remaining ({splitPreviewData.preview?.customer_refs_remaining?.length || 0})
                      </Typography>
                      {splitPreviewData.preview?.customer_refs_remaining?.map((ref, idx) => <Box key={idx} sx={{
                ml: 1,
                mb: 1,
                p: 1,
                bgcolor: '#f5f5f5',
                borderRadius: 1,
                fontSize: '14px'
              }}>
                          <Typography variant="body2">
                            {ref.first_name} {ref.last_name} - {ref.email || ref.phone || 'No contact info'}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            Source: {ref.entity_source}
                          </Typography>
                        </Box>)}
                    </Box>
                  </Box>

                  {/* New Customer */}
                  <Box sx={{
            flex: 1,
            border: '1px solid #EDEFF1',
            borderRadius: '8px',
            overflow: 'hidden'
          }}>
                    <Box sx={{
              backgroundColor: '#F3F6FC',
              p: 2,
              borderBottom: '1px solid #EDEFF1'
            }}>
                      <Typography fontSize={'18px'} fontWeight={'600'}>
                        New Customer Preview
                      </Typography>
                    </Box>
                    <Box sx={{
              p: 2
            }}>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{
                      border: 0,
                      py: 1,
                      px: 0
                    }}>
                              <Typography variant="tableHeader" sx={{
                        fontSize: '16px',
                        fontWeight: 'bold'
                      }}>
                                {splitPreviewData.preview?.new_customer?.first_name} {splitPreviewData.preview?.new_customer?.last_name}
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{
                      border: 0,
                      py: 1,
                      px: 0
                    }}>
                              <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center'
                      }}>
                                <CallFilledIcon />
                                <Typography sx={{
                          pl: '10px'
                        }}>
                                  {splitPreviewData.preview?.new_customer?.phone || 'No Phone Number'}
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{
                      border: 0,
                      py: 1,
                      px: 0
                    }}>
                              <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center'
                      }}>
                                <MailEnvelopeFilledIcon size="sm" />
                                <Typography sx={{
                          pl: '10px'
                        }}>{splitPreviewData.preview?.new_customer?.email || 'No Email'}</Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{
                      border: 0,
                      py: 1,
                      px: 0
                    }}>
                              <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center'
                      }}>
                                <LocationOnFilledIcon />
                                {!splitPreviewData.preview?.new_customer?.address1 && !splitPreviewData.preview?.new_customer?.address2 && !splitPreviewData.preview?.new_customer?.city && !splitPreviewData.preview?.new_customer?.state && !splitPreviewData.preview?.new_customer?.zip_code ? <Typography sx={{
                          pl: '10px'
                        }}>No Address</Typography> : <Typography sx={{
                          pl: '10px'
                        }}>
                                    {[[splitPreviewData.preview?.new_customer?.address1, splitPreviewData.preview?.new_customer?.address2].filter(Boolean).join(' '), [splitPreviewData.preview?.new_customer?.city, splitPreviewData.preview?.new_customer?.state].filter(Boolean).join(', '), splitPreviewData.preview?.new_customer?.zip_code].filter(Boolean).join(' ')}
                                  </Typography>}
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>

                      <Typography variant="tableHeader" sx={{
                mt: 2,
                mb: 1
              }}>
                        Customer References Moving ({splitPreviewData.preview?.customer_refs_to_move?.length || 0})
                      </Typography>
                      {splitPreviewData.preview?.customer_refs_to_move?.map((ref, idx) => <Box key={idx} sx={{
                ml: 1,
                mb: 1,
                p: 1,
                bgcolor: '#e8f5e8',
                borderRadius: 1,
                fontSize: '14px'
              }}>
                          <Typography variant="body2">
                            {ref.first_name} {ref.last_name} - {ref.email || ref.phone || 'No contact info'}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            Source: {ref.entity_source}
                          </Typography>
                        </Box>)}
                    </Box>
                  </Box>
                </Box>
              </Box> : <p>No preview data available</p>}
          </div>} actions={<div style={{
      display: 'flex',
      gap: '10px',
      justifyContent: 'flex-end'
    }}>
              <Button actionType="flat" onClick={closeSplitModal}>
                Cancel
              </Button>
              <Button actionType="primary" onClick={executeSplit} disabled={!splitPreviewData || isLoadingSplitPreview}>
                Confirm Split
              </Button>
            </div>} />}
    </>;
}